import { useState } from 'react';
import { message } from 'antd';

export const useMessageList = (stepForm, currentStep, setCurrentStep) => {
    const [messageList, setMessageList] = useState([]);

    // 添加多消息
    const handleAddMessage = () => {
        // 获取当前步骤表单值
        const values = stepForm.getFieldsValue();

        // 只有MESSAGE类型才能添加多消息
        if (values.type !== 'MESSAGE') {
            message.warning('只有消息类型步骤才能添加多条消息');
            return;
        }

        // 验证消息类型限制
        const { actionType, actionParams } = values;

        // 检查是否已存在相同类型的消息
        const hasTextMessage = messageList.some(msg => msg.type === 'TEXT');
        const hasImageMessages = messageList.filter(msg => msg.type === 'IMAGE').length;
        const hasOtherAttachmentTypes = messageList
            .filter(msg => ['VIDEO', 'FILE', 'LINK', 'MINIPROGRAM'].includes(msg.type))
            .map(msg => msg.type);

        // 文本消息限制：最多一条
        if (actionType === 'TEXT') {
            if (hasTextMessage) {
                message.warning('每个步骤最多只能添加一条文本消息');
                return;
            }
            if (!actionParams?.content) {
                message.error('请填写消息内容');
                return;
            }
        }
        // 图片消息限制：最多9张
        else if (actionType === 'IMAGE') {
            if (hasImageMessages >= 9) {
                message.warning('图片附件最多只能添加9张');
                return;
            }
            if (!actionParams?.mediaId) {
                message.error('请上传媒体文件');
                return;
            }
        }
        // 其他附件类型限制：每种类型最多1个，且不能混合使用不同类型
        else if (['VIDEO', 'FILE', 'LINK', 'MINIPROGRAM'].includes(actionType)) {
            if (hasOtherAttachmentTypes.length > 0 && !hasOtherAttachmentTypes.includes(actionType)) {
                message.warning('每个步骤只能添加一种类型的附件（图片除外）');
                return;
            }
            if (hasOtherAttachmentTypes.includes(actionType)) {
                message.warning(`${actionType}类型的附件最多只能添加1个`);
                return;
            }

            // 验证表单字段完整性
            if (actionType === 'VIDEO' || actionType === 'FILE') {
                if (!actionParams?.mediaId) {
                    message.error(`请上传${actionType === 'VIDEO' ? '视频' : '文件'}`);
                    return;
                }
            } else if (actionType === 'LINK') {
                if (!actionParams?.title || !actionParams?.url) {
                    message.error('请填写链接标题和地址');
                    return;
                }
            } else if (actionType === 'MINIPROGRAM') {
                if (!actionParams?.title || !actionParams?.appid || !actionParams?.pagepath || !actionParams?.thumbMediaId) {
                    message.error('请填写小程序信息');
                    return;
                }
            }
        }

        // 创建消息对象
        const newMessage = {
            id: actionType.toLowerCase() + '-' + Date.now() + Math.random(),
            type: actionType,
            params: {}
        };

        // 根据消息类型设置正确的参数结构
        if (actionType === 'TEXT') {
            newMessage.params = { content: actionParams?.content || '' };
        } else if (['IMAGE', 'VIDEO', 'FILE'].includes(actionType)) {
            newMessage.params = { mediaId: actionParams?.mediaId || '' };
        } else if (actionType === 'LINK') {
            newMessage.params = {
                title: actionParams?.title || '',
                description: actionParams?.description || '',
                url: actionParams?.url || '',
                picUrl: actionParams?.picUrl || ''
            };
        } else if (actionType === 'MINIPROGRAM') {
            newMessage.params = {
                title: actionParams?.title || '',
                appid: actionParams?.appid || '',
                pagepath: actionParams?.pagepath || '',
                thumbMediaId: actionParams?.thumbMediaId || ''
            };
        }

        // 添加到消息列表
        const newMessageList = [...messageList, newMessage];
        setMessageList(newMessageList);

        // 如果正在编辑的步骤是消息类型，更新步骤对象
        if (currentStep && currentStep.type === 'MESSAGE') {
            const updatedStep = { ...currentStep, messageList: newMessageList };
            setCurrentStep(updatedStep);
        }

        // 清空相关字段
        if (actionType === 'TEXT') {
            stepForm.setFieldsValue({
                actionParams: {
                    ...actionParams,
                    content: ''
                }
            });
        } else if (['IMAGE', 'VIDEO', 'FILE'].includes(actionType)) {
            stepForm.setFieldsValue({
                actionParams: {
                    ...actionParams,
                    mediaId: undefined
                }
            });
        } else if (actionType === 'LINK') {
            stepForm.setFieldsValue({
                actionParams: {
                    ...actionParams,
                    title: '',
                    description: '',
                    url: '',
                    picUrl: undefined
                }
            });
        } else if (actionType === 'MINIPROGRAM') {
            stepForm.setFieldsValue({
                actionParams: {
                    ...actionParams,
                    title: '',
                    appid: '',
                    pagepath: '',
                    thumbMediaId: undefined
                }
            });
        }

        message.success('消息添加成功');
    };

    // 删除多消息
    const handleDeleteMessage = (messageId) => {
        console.log('父组件开始删除消息:', messageId, '当前列表:', messageList);

        // 更新父组件消息列表
        const newMessageList = messageList.filter(msg => msg.id !== messageId);
        console.log('删除后的消息列表:', newMessageList);

        // 更新状态
        setMessageList(newMessageList);

        // 如果正在编辑的步骤是消息类型，更新步骤对象
        if (currentStep && currentStep.type === 'MESSAGE') {
            const updatedStep = { ...currentStep, messageList: newMessageList };
            setCurrentStep(updatedStep);
            console.log('已更新当前步骤的消息列表:', updatedStep);
        }

        message.success('消息删除成功');
    };

    return {
        messageList,
        setMessageList,
        handleAddMessage,
        handleDeleteMessage
    };
}